<script lang="ts">
/**
 * Dashboard section showing recently accessed containers.
 *
 * Renders a labeled list of container rows (dashboard variant) with
 * a "See all" link to the full containers index.
 *
 * @example
 * ```vue
 * <RecentContainersSection :containers="recent_containers" />
 * ```
 */
export interface RecentContainersSectionProps {
  /** Recent containers from the backend. */
  containers: ContainerSummary[]
}
</script>

<script setup lang="ts">
import { SbSectionedList } from "@unio/saltbox-ui"

import ContainerRow from "@/components/ContainerRow.vue"
import { containersPath } from "@/routes"
import type { ContainerSummary } from "@/types/models"

defineProps<RecentContainersSectionProps>()
</script>

<template>
  <SbSectionedList label="Recent Containers">
    <template #trailing>
      <UButton
        label="See all"
        variant="link"
        color="primary"
        trailing-icon="i-lucide-arrow-right"
        size="sm"
        :to="containersPath()"
      />
    </template>
    <ContainerRow
      v-for="container in containers"
      :key="container.id"
      :container="container"
      variant="dashboard"
    />
  </SbSectionedList>
</template>
